import { render, staticRenderFns } from "./PasajerosVehiculos.vue?vue&type=template&id=f5628c84&lang=pug&"
import script from "./PasajerosVehiculos.vue?vue&type=script&lang=js&"
export * from "./PasajerosVehiculos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports